import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class ParallaxImage {
	constructor() {
		this.containers = document.querySelectorAll('[data-parallax-image]')

		if (!this.containers.length) return

		this.#init()
	}

	#init() {
		this.containers.forEach((container) => this.#createParallax(container))
	}

	#createParallax(container) {
		const image = container.querySelector('img')

		if (!image) return

		const amount = 15

		gsap.set(image, {
			height: `${100 + amount * 2}%`,
			top: `-${amount}%`,
		})

		gsap.fromTo(
			image,
			{ yPercent: -amount },
			{
				yPercent: amount,
				ease: 'none',
				scrollTrigger: {
					trigger: container,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
			}
		)
	}
}
